import { $ } from '@zeus/index'
import { typedGql } from '@zeus/typedDocumentNode'

export const GQL_IMPERSONATE = typedGql('mutation')({
  impersonateUser: [
    { userId: $('userId', 'String!') },
    {
      __typename: true,
      '...on UserInfo': {
        email: true,
        firstName: true,
        lastName: true,
        roles: true,
        id: true,
      },
      '...on CustomError': {
        error: true,
        message: true,
      },
    },
  ],
})

export const GQL_LOGIN = typedGql('mutation')({
  login: [
    { email: $('email', 'String!'), password: $('password', 'String!') },
    {
      __typename: true,
      '...on UserInfo': {
        firstName: true,
        lastName: true,
        roles: true,
        email: true,
        id: true,
      },
      '...on CustomError': {
        error: true,
        message: true,
      },
    },
  ],
})

export const GQL_SEND_RESET_PASSWORD = typedGql('mutation')({
  askForResetPassword: [{ email: $('email', 'String!') }, true],
})

export const GQL_RESET_PASSWORD = typedGql('mutation')({
  resetPassword: [
    {
      email: $('email', 'String!'),
      password: $('password', 'String!'),
      token: $('token', 'String!'),
    },
    true,
  ],
})

export const GQL_REFRESH = typedGql('mutation')({
  refresh: {
    __typename: true,
    '...on UserInfo': {
      firstName: true,
      lastName: true,
      roles: true,
      email: true,
      id: true,
    },
    '...on CustomError': {
      error: true,
      message: true,
    },
  },
})

export const GQL_LOGOUT = typedGql('mutation')({
  logout: true,
})

export const GQL_ASK_REGISTER = typedGql('mutation')({
  askForRegister: [
    {
      registerUserInput: $('registerUserInput', 'RegisterUserInput!'),
    },
    true,
  ],
})

export const GQL_LOGIN_UNIQUE = typedGql('query')({
  uniqueAuthFromSso: [
    {
      code: $('code', 'String!'),
    },
    {
      access_token: true,
      firstName: true,
      lastName: true,
      role: true,
      email: true,
      id: true,
    },
  ],
})

export const GQL_FINISH_REGISTER = typedGql('mutation')({
  finishRegister: [
    {
      email: $('email', 'String!'),
      password: $('password', 'String!'),
      firstName: $('firstName', 'String!'),
      lastName: $('lastName', 'String!'),
      token: $('token', 'String!'),
    },
    true,
  ],
})

export const GQL_CREATE_ACCOUNT = typedGql('mutation')({
  register: [
    {
      email: $('email', 'String!'),
      password: $('password', 'String!'),
      firstName: $('firstName', 'String!'),
      lastName: $('lastName', 'String!'),
    },
    {
      __typename: true,
      '...on UserInfo': {
        email: true,
        firstName: true,
        lastName: true,
        roles: true,
        id: true,
      },
      '...on CustomError': {
        error: true,
        message: true,
      },
    },
  ],
})

export const GQL_VERIFY_ACCOUNT = typedGql('mutation')({
  verifyEmail: [
    {
      email: $('email', 'String!'),
      token: $('token', 'String!'),
    },
    true,
  ],
})

export const GQL_RESEND_EMAIL_VALIDATION = typedGql('mutation')({
  reSendEmailValidation: [
    {
      email: $('email', 'String!'),
    },
    true,
  ],
})

export const GQL_ME = typedGql('query')({
  me: {
    firstName: true,
    lastName: true,
    email: true,
    roles: true,
    id: true,
  },
})
